import React, { useState } from 'react'
import { Form, useNavigate } from 'react-router-dom'

import PageHeader from '../../components/Typography/PageHeader'
import { useAuth } from '../../applications/hooks/UseAuth'
import OrderTrackingList from '../order_tracking/components/OrderTrackingList'
import OrderTrackingAgroService from './services/AgroCustomerOrder'
import OrderTrackingView from '../order_tracking/components/OrderTrackingView'

const CURRENT_PAGE = 'agroforestry_commande'

function AgroCustomerOrder() {
    const service = OrderTrackingAgroService.load()
    const { haveAccessTo } = useAuth()
    const [needLoad, setNeedLoad] = useState(true)
    const useDrawer = true

    return (
        <>
            <PageHeader title={'Commandes agroforesterie'} subTitle={'Commandes agroforesterie'}></PageHeader>

            <OrderTrackingList
                service={service}
                needLoad={needLoad}
                setNeedLoad={setNeedLoad}
                haveAccessTo={haveAccessTo}
                Form={OrderTrackingView}
                drawer={useDrawer}
                currentPage={CURRENT_PAGE}
            />
        </>
    )
}

export default AgroCustomerOrder
